import CustomField from "@mapmycustomers/shared/types/customField/CustomField";
import { EntityType, EntityTypeSupportingCustomFields } from "@mapmycustomers/shared/types/entity";
import { PickWithType } from "@mapmycustomers/shared/util/ts";

import CustomFieldsState from "./CustomFieldsState";

export const stateFieldBaseName: {
  [key in EntityTypeSupportingCustomFields]: keyof PickWithType<CustomFieldsState, CustomField[]>;
} = {
  [EntityType.ACTIVITY]: "activityCustomFields",
  [EntityType.COMPANY]: "companyCustomFields",
  [EntityType.DEAL]: "dealCustomFields",
  [EntityType.PERSON]: "peopleCustomFields",
};
